//Ticket Template Data
export const ticketModel = {
  ticketId: 0,
  ticketType: 0,
  ticketNo: "",
  bookletId: 0,
  booklet: null,
  lastName: "",
  firstName: "",
  middleName: "",
  suffix: "",
  address1: "",
  address2: "",
  province: "",
  provinceData: null,
  city: "",
  cityData: null,
  barangay: "",
  barangayData: null,
  birthDate: null,
  gender: 0,
  genderData: null,
  contactNo: "",
  email: "",
  vehicleId: 0,
  vehicle: null,
  vehicleClassificationData: null,
  vehicleClassification: 0,
  vehicleOwner: "",
  ownerAddress: "",
  plateNumber: "",
  licenseNo: "",
  registrationNo: "",
  vehicleRemarks: "",
  violationSummary: "",
  incidentPlaceId: 0,
  incidentPlace: "",
  incidentPlaceData: null,
  incidentBarangay: "",
  incidentBarangayData: null,
  incidentDate: "",
  incidentTime: "",
  // isTicketAccident: false,
  sector: "",
  district: "",
  isInvolveInAccident: false,
  confiscatedItem: "",
  confiscatedItemData: null,
  otherConfiscatedItem: "",
  apprehendingOfficer: "",
  enforcerId: 0,
  enforcer: null,
  details: [],
  createdBy: "",
  created: new Date(),
  lastIssuedTicket: null,
  deleted: false,
  hold: false,
  holdTicket: null,
  latitude: 0,
  longitude: 0,
};

export const ticketDetailModel = {
  violationId: 0,
  orderNo: 0,
  offenseCount: 0,
  fine: 0,
};

export const ticketDetails = {
  allocatedBookletId: 3,
  enforcer: {
    enforcerId: 0,
    lastName: "",
    firstName: "",
    middleName: "",
    deputationNo: "00001",
    contactNo: "09123456789",
    email: "test@gmail.com",
    assignedAreaId: 0,
    assignedArea: null,
    isActive: true,
  },
  booklet: {
    bookletId: 3,
    supplierId: 1,
    bookletNo: "OVR2101000000300",
    startNo: "01",
    endNo: "50",
    dateReceived: "2021-06-04T02:45:58.321Z",
    supplier: null,
  },
};
